import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Button, Typography, TextField, InputAdornment, Icon, Checkbox,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import ResetPasswordDialog from './ResetPasswordDialog';
import RecoveryTokenDialog from './RecoveryTokenDialog';
import NewPasswordDialog from './NewPasswordDialog';

import Logo from '../../assets/img/Craver_Logo_horizontal.svg';
import Background from '../../assets/img/background_login.png';
import { loginPageStyles } from '../../css/style';

import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';

const styles = loginPageStyles();

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
      password: null,
      forgotPasswordDialog: false,
      recoveryTokenDialog: false,
      newPasswordDialog: false,
      enteredEmail: '',
      recoveryToken1: '',
      recoveryToken2: '',
      recoveryToken3: '',
      recoveryToken4: '',
      recoveryToken5: '',
      newPassword: '',
      reTypedNewPassword: '',
      errorText: '',
      rememberUser: '',
    };
  }

  onChangeInput = (field, event) => {
    const newState = event.target.value;
    this.setState({ [field]: newState });
  }

  onClickLogin = () => {
    const { actions } = this.props;
    const {
      forgotPasswordDialog,
      recoveryTokenDialog,
      newPasswordDialog,
      enteredEmail,
      enteredToken,
      recoveryToken1,
      recoveryToken2,
      recoveryToken3,
      recoveryToken4,
      recoveryToken5,
      newPassword,
      reTypedNewPassword,
      errorText,
      rememberUser,
      ...admin
    } = this.state;
    actions.loginAdmin(admin)
      .then((res) => {
        if (!res.error) {
          if (rememberUser) {
            localStorage.setItem('admin', JSON.stringify(res.loggedInAdmin));
          }
          sessionStorage.setItem('admin', JSON.stringify(res.loggedInAdmin));
        }
      });
  }

  /**
   * onChange functions for dialogs
   */

  onEmailTextFieldchange = (event) => {
    this.setState({ enteredEmail: event.target.value });
  }

  onTokenTextFieldChange = (e, fieldName) => {
    if (!this.state[fieldName]) {
      switch (fieldName) {
        case 'recoveryToken1':
          this.token2Input.focus();
          break;
        case 'recoveryToken2':
          this.token3Input.focus();
          break;
        case 'recoveryToken3':
          this.token4Input.focus();
          break;
        case 'recoveryToken4':
          this.token5Input.focus();
          break;
        default:
          break;
      }
    }
    this.setState({
      [fieldName]: e.target.value,
    });
  }

  tokenInputRef = (fieldInput, input) => {
    if (fieldInput.position === 2) {
      this.token2Input = input;
    } else if (fieldInput.position === 3) {
      this.token3Input = input;
    } else if (fieldInput.position === 4) {
      this.token4Input = input;
    } else if (fieldInput.position === 5) {
      this.token5Input = input;
    } else return;
  }

  onNewPasswordTextFieldChange = (inputVal, type) => {
    if (type === 'first') {
      this.setState({ newPassword: inputVal.target.value });
    } else {
      this.setState({ reTypedNewPassword: inputVal.target.value });
    }
  }

  /**
   * onClose functions for dialogs
   */

  onCloseResetPasswordDialog = () => {
    const { forgotPasswordDialog } = this.state;
    this.setState({
      forgotPasswordDialog: !forgotPasswordDialog,
      enteredEmail: '',
      errorText: '',
    });
  }

  onRecoveryTokenClose = () => {
    const { recoveryTokenDialog } = this.state;
    this.setState({
      recoveryTokenDialog: !recoveryTokenDialog,
      enteredEmail: '',
      recoveryToken1: '',
      recoveryToken2: '',
      recoveryToken3: '',
      recoveryToken4: '',
      recoveryToken5: '',
      errorText: '',
    });
  }

  onNewPasswordClose = () => {
    const { newPasswordDialog } = this.state;
    this.setState({
      newPasswordDialog: !newPasswordDialog,
      enteredEmail: '',
      recoveryToken1: '',
      recoveryToken2: '',
      recoveryToken3: '',
      recoveryToken4: '',
      recoveryToken5: '',
      errorText: '',
    });
  }

  /**
   * onClick functions for dialogs
   */

  onClickSendToken = () => {
    const { actions } = this.props;
    const { enteredEmail, forgotPasswordDialog, recoveryTokenDialog } = this.state;
    const reqObj = { email: enteredEmail };
    if (enteredEmail) {
      actions.getRecoveryToken(reqObj)
        .then((res) => {
          if (!res.error) {
            this.setState({
              forgotPasswordDialog: !forgotPasswordDialog,
              recoveryTokenDialog: !recoveryTokenDialog,
              errorText: '',
            });
          } else {
            this.setState({ errorText: res.error });
          }
        });
    }
  }

  onClickNextInToken = () => {
    const { actions } = this.props;
    const {
      enteredEmail,
      recoveryTokenDialog,
      newPasswordDialog,
      recoveryToken1,
      recoveryToken2,
      recoveryToken3,
      recoveryToken4,
      recoveryToken5,
    } = this.state;
    const enteredToken = `${recoveryToken1}${recoveryToken2}${recoveryToken3}${recoveryToken4}${recoveryToken5}`;
    const reqObj = {
      email: enteredEmail,
      token: enteredToken,
    };
    if (enteredToken) {
      actions.verifyRecoveryToken(reqObj)
        .then((res) => {
          if (!res.error) {
            this.setState({
              recoveryTokenDialog: !recoveryTokenDialog,
              newPasswordDialog: !newPasswordDialog,
              errorText: '',
            });
          } else {
            this.setState({ errorText: 'Incorrect Token' });
          }
        });
    }
  }

  onClickReset = () => {
    const { actions } = this.props;
    const {
      enteredEmail, newPassword, reTypedNewPassword, newPasswordDialog,
    } = this.state;
    const reqObj = {
      email: enteredEmail,
      password: newPassword,
    };
    if (newPassword === reTypedNewPassword) {
      actions.confirmResetPassword(reqObj)
        .then((res) => {
          if (!res.error) {
            this.setState({
              newPasswordDialog: !newPasswordDialog,
              recoveryToken1: '',
              recoveryToken2: '',
              recoveryToken3: '',
              recoveryToken4: '',
              errorText: '',
            });
          }
        });
    } else {
      this.setState({ errorText: 'Passwords are different' });
    }
  }

  onRememberCheckBoxChange = (event) => {
    const { actions } = this.props;
    this.setState({ rememberUser: event.target.checked });
  }

  updateComponentName = (width, component) => {
    if (width === 'sm') return `${component}Tablet`;
    if (width === 'xs') return `${component}Mobile`;
    return component;
  }

  getDeviceStyles = (width, component) => {
    if (!width) {
      return styles[component];
    }
    component = this.updateComponentName(width, component);
    return styles[component];
  }

  render() {
    const { errors, width } = this.props;

    return (
      <div style={styles.container}>
        <img src={Background} style={styles.backgroundImg} alt="Background" />
        <div style={this.getDeviceStyles(width, 'inputContainer')}>
          <img src={Logo} style={styles.logo} alt="Craver Logo" />
          <div style={styles.textBoxContainer}>
            <Typography style={this.getDeviceStyles(width, 'welcomeTextBox')}>WELCOME TO</Typography>
          &nbsp;&nbsp;
            <Typography style={this.getDeviceStyles(width, 'craverTextBox')}>CRAVER</Typography>
          </div>
          <div style={styles.inputSection}>
            <TextField
              id="email"
              placeholder="EMAIL"
              onChange={(event) => { this.onChangeInput('email', event); }}
              style={this.getDeviceStyles(width, 'textField')}
              variant="outlined"
            />
            <TextField
              id="password"
              type="password"
              onChange={(event) => { this.onChangeInput('password', event); }}
              style={this.getDeviceStyles(width, 'textField')}
              placeholder="PASSWORD"
              variant="outlined"
            />
          </div>
          <Button style={this.getDeviceStyles(width, 'loginBtn')} variant="contained" onClick={() => this.onClickLogin()}>Log in</Button>
          {
            errors
            && <div style={{ color: 'red', fontFamily: 'Lato' }}>{errors}</div>
          }
          <div style={styles.forgetPassword}>
            <div
              style={styles.rememberAdminContainer}
            >
              <Checkbox
                color="primary"
                style={styles.rememberAdminCheckBox}
                onChange={event => this.onRememberCheckBoxChange(event)}
              />
              <Typography style={(width !== 'xs') ? styles.rememberAdminText : styles.rememberAdminTextMobile}>Remember me</Typography>
            </div>
            <Typography
              style={(width !== 'xs') ? styles.forgotPasswordText : styles.forgotPasswordTextMobile}
              onClick={() => this.setState({ forgotPasswordDialog: !this.state.forgotPasswordDialog })}
            >
              Forgot password
            </Typography>
          </div>
          <ResetPasswordDialog
            dialogState={this.state.forgotPasswordDialog}
            onClose={this.onCloseResetPasswordDialog}
            onClickNext={this.onClickSendToken}
            onTextFieldChange={this.onEmailTextFieldchange}
            errorText={this.state.errorText}
            width={this.props.width}
          />
          <RecoveryTokenDialog
            dialogState={this.state.recoveryTokenDialog}
            onClose={this.onRecoveryTokenClose}
            onClickNext={this.onClickNextInToken}
            enteredEmail={this.state.enteredEmail}
            recoveryToken1={this.state.recoveryToken1}
            recoveryToken2={this.state.recoveryToken2}
            recoveryToken3={this.state.recoveryToken3}
            recoveryToken4={this.state.recoveryToken4}
            recoveryToken5={this.state.recoveryToken5}
            onTextFieldChange={this.onTokenTextFieldChange}
            tokenInputRef={this.tokenInputRef}
            errorText={this.state.errorText}
          />
          <NewPasswordDialog
            dialogState={this.state.newPasswordDialog}
            onClose={this.onNewPasswordClose}
            onClickConfirm={this.onClickReset}
            onTextFieldChange={this.onNewPasswordTextFieldChange}
            errorText={this.state.errorText}
            isTablet={this.isTablet}
          />
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any),
};

Login.defaultProps = {
  errors: null,
};

export default withWidth()(withRouter(Login));
